import {gsap} from "../LibrariesImport";

export default class Lexique {
	static init() {

		const definitions = window.dictionaryDefinitions;
		if (!definitions || !definitions.length) {
			return;
		}

		const definitionMapping = {};
		definitions.forEach(item => {
			if (item.link) {
				definitionMapping[item.link] = item;
			}
		});

		const tooltip = document.querySelector(".lexique-tooltip");
		tooltip.classList.remove("active");

		const links = document.querySelectorAll(`.rich-text a[data-lexique]`);
		links.forEach(link => {
			const richText = link.closest(".rich-text");
			link.addEventListener("mouseenter", e => {
				link.selected = definitionMapping[e.target.dataset.lexique];
				if (!link.selected) {
					return;
				}
				link.classList.add("active");
				tooltip.classList.add("active");
				richText.classList.add("active");
				const content = tooltip.querySelector(".lexique-content");
				// const image = tooltip.querySelector(".lexique-image");
				content.innerHTML = link.selected.content;
				// image.setAttribute("srcset", link.selected.imgSrcSet);
				// image.setAttribute("src", link.selected.imgSrc);
				// image.setAttribute("width", link.selected.imgWidth);
				// image.setAttribute("height", link.selected.imgHeight);
				link.selected.tooltipWidth = tooltip.clientWidth;
				link.selected.tooltipHeight = tooltip.clientHeight;
			});

			link.addEventListener("mousemove", e => {
				let positionX = "left";
				let positionY = "top";
				let newX = e.clientX;
				let newY = e.clientY;
				tooltip.classList.remove("right", "left", "bottom", "top");

				if (window.innerWidth < 768){
					newX = 15;
					newY = newY + 40;
				}
				else{
					if (link.selected.tooltipWidth < newX) {
						newX = newX - link.selected.tooltipWidth - 2;
						positionX = "right";
					}

					if (newY > link.selected.tooltipHeight) {
						newY = newY - link.selected.tooltipHeight - 7;
						positionY = "bottom";
					}else{
						newY+=20;
					}

					tooltip.classList.add(positionX);
					tooltip.classList.add(positionY);
				}

				gsap.set(tooltip, {x: newX, y: newY});
			});

			link.addEventListener("mouseleave", () => {
				link.classList.remove("active");
				tooltip.classList.remove("active");
				richText.classList.remove("active");
			});
		});
	}
}
